import { Button, Result, Spin } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { useGetPostQuery } from '@/generated/graphql'
import { PostCard } from '@/modules/post/post-card'

interface SinglePostProps {
  postId: number
}

export const SinglePost: React.FC<SinglePostProps> = ({ postId }) => {
  const { t } = useTranslation()
  const history = useHistory()

  const parentCommentPagination = {
    last: 1000,
  }

  const childCommentPagination = {
    last: 1000,
  }

  const { data, loading, error } = useGetPostQuery({
    fetchPolicy: 'network-only',
    variables: {
      postId,
      parentCommentPagination,
      childCommentPagination,
    },
  })

  if (error) {
    return (
      <div style={{ height: '90vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Result
          status='404'
          title={t('page.post.notFound')}
          extra={
            <Button type='primary' onClick={() => history.goBack()}>
              Back
            </Button>
          }
        />
      </div>
    )
  }

  if (loading || !data) {
    return <Spin size='large' />
  }

  const { post } = data

  return (
    <PostCard
      post={post}
      isSinglePost={true}
      parentCommentPagination={parentCommentPagination}
      childCommentPagination={childCommentPagination}
    />
  )
}
